module.exports = __webpack_public_path__ + "img/PK.cc31e7eb.svg";